import React, { useState, useMemo } from 'react';
import { Table, Switch } from 'antd';
import { useTranslation } from 'react-i18next';
import { createTableColumns } from '../../config/resultsTableConfig';

/**
 * ResultsTable Component
 * Displays risk calculation results in a table format
 *
 * @param {Object} props - Component props
 * @param {Array} props.data - Array of ResultRow objects to display
 * @param {Function} props.onEdit - Handler for edit action (null in read-only mode)
 * @param {Function} props.onDuplicate - Handler for duplicate action (null in read-only mode)
 * @param {Function} props.onDelete - Handler for delete action (null in read-only mode)
 * @param {boolean} props.loading - Loading state for the table
 * @param {boolean} props.readOnly - Whether the table is in read-only mode (hides actions)
 */
const ResultsTable = ({
  data = [],
  onEdit,
  onDuplicate,
  onDelete,
  loading = false,
  readOnly = false,
}) => {
  const { t } = useTranslation('riskCalculator');
  const [showRiskStyle, setShowRiskStyle] = useState(() => localStorage.getItem('sage-show-bordered-table') !== 'false');

  const handleShowRiskStyleChange = (checked) => {
    setShowRiskStyle(checked);
    localStorage.setItem('sage-show-bordered-table', String(checked));
  };

  // Memoize columns configuration to prevent unnecessary re-renders
  const columns = useMemo(() => {
    return createTableColumns(
      t,
      {
        onEdit,
        onDuplicate,
        onDelete,
      },
      readOnly
    );
  }, [t, onEdit, onDuplicate, onDelete, readOnly]);

  return (
    <div>
      <div className="flex gap-[8px] items-center mb-[16px]">
        <Switch
          checked={showRiskStyle}
          onChange={handleShowRiskStyleChange}
        />
        <span>{t('common|Afficher le tableau avec bordures')}</span>
      </div>
      <Table
        className={!showRiskStyle ? 'risk-results-table' : ''}
      columns={columns}
      dataSource={data}
      rowKey="id"
      loading={loading}
      pagination={false}
      bordered
      size="small"
      scroll={{ x: 'max-content' }}
    />
    </div>
  );
};

export default ResultsTable;
